export default "__VITE_ASSET__660f6001__"